(function () {
  'use strict';
  var NO_DISCOVERY_TAG = 'no-discovery';
  if (window.theme && window.theme.settings && window.theme.settings.predictiveSearch === false) return;
  var _originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) ? input.url : '';
    if (url && url.indexOf('/search/suggest') !== -1) {
      return _originalFetch.call(this, input, init).then(function (response) {
        var cloned = response.clone();
        return cloned.json().then(function (data) {
          try {
            if (data && data.resources && data.resources.results && data.resources.results.products) {
              data.resources.results.products = data.resources.results.products.filter(function (product) {
                if (!product.tags) return true;
                var tags = Array.isArray(product.tags) ? product.tags : product.tags.split(',').map(function (t) { return t.trim(); });
                return tags.indexOf(NO_DISCOVERY_TAG) === -1;
              });
            }
          } catch (e) {}
          return new Response(JSON.stringify(data), { status: response.status, statusText: response.statusText, headers: response.headers });
        }).catch(function () { return response; });
      });
    }
    return _originalFetch.apply(this, arguments);
  };
})();
